import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SpinnerInline } from '../../components/spinner';
import { parsers } from '../../helpers';
import ClickToViewState from '../../shared/click-to-view-states';
import { conversionEvents, otherEvents } from '../../shared/tracking';
import { phonenumbers } from '../../utils';

interface ActionPhonenumberProps {
  phonenumber: string;
  isGenerationActive: boolean;
  getParams: (params: any) => void;
  trackerOther: (event: string) => void;
  trackerConversion: (event: string) => void;
}

const ActionPhonenumber = ({
  phonenumber,
  isGenerationActive,
  getParams,
  trackerOther,
  trackerConversion,
}: ActionPhonenumberProps) => {
  const { t } = useTranslation(['retailer']);
  const [state, setState] = useState({
    currentState: ClickToViewState.Hidden,
    phonenumber: parsers.parsePhoneNumber(phonenumber),
  });

  const onGenerationComplete = (generated: string) => {
    const phonenumber = parsers.parsePhoneNumber(generated);
    setState({ ...state, currentState: ClickToViewState.Visible, phonenumber });
  };

  const onClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (state.currentState === ClickToViewState.Visible) {
      trackerOther(otherEvents.CONVERSION_PHONENUMBER_CALL_RETAILER);
    } else {
      e.preventDefault();
      e.stopPropagation();
      trackerConversion(conversionEvents.PHONENUMBER_VISIBLE_RETAILER);

      if (isGenerationActive) {
        setState({ ...state, currentState: ClickToViewState.Processing });
        phonenumbers.convert(
          state.phonenumber.international || '',
          getParams,
          onGenerationComplete,
        );
      } else {
        setState({ ...state, currentState: ClickToViewState.Visible });
      }
    }
  };

  if (state.currentState === ClickToViewState.Processing) {
    return (
      <li className="m-b">
        <button
          type="button"
          disabled
          data-am-button="primary-clear no-padding text-left text-regular square"
        >
          <div className="table">
            <div className="td td-minimal valign-middle">
              <div data-am-icon="primary">
                <i className="icon-phone" />
              </div>
            </div>
            <div className="td valign-middle p-l-half">
              <SpinnerInline />
            </div>
          </div>
        </button>
      </li>
    );
  }

  if (state.currentState === ClickToViewState.Visible) {
    return (
      <li className="m-b">
        <a
          href={state.phonenumber.e164}
          title={t('callUs', { ns: 'retailer' })}
          data-am-button="primary-clear no-padding text-left text-regular square"
          onClick={onClick}
        >
          <div className="table">
            <div className="td td-minimal valign-middle">
              <div data-am-icon="primary">
                <i className="icon-phone" />
              </div>
            </div>
            <div className="td valign-middle p-l-half">
              <div className="font-regular text-dark-lighten font-size-small m-b-mini">
                {t('callUs', { ns: 'retailer' })}
              </div>
              <div>{state.phonenumber.national}</div>
            </div>
          </div>
        </a>
      </li>
    );
  }

  return (
    <li className="m-b">
      <button
        type="button"
        title={t('showPhoneNumber', { ns: 'retailer' })}
        data-am-button="primary-clear no-padding text-left text-regular square"
        onClick={onClick}
      >
        <div className="table">
          <div className="td td-minimal valign-middle">
            <div data-am-icon="primary">
              <i className="icon-phone" />
            </div>
          </div>
          <div className="td valign-middle p-l-half">
            <div>{t('showPhoneNumber', { ns: 'retailer' })}</div>
          </div>
        </div>
      </button>
    </li>
  );
};

export default ActionPhonenumber;
